import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AppliedRoute from './components/AppliedRoute';
import Home from './containers/Home';
import NotFound from './containers/NotFound';


export default () => (
		<Switch>
			<AppliedRoute path="/" exact component={Home}/>
			<AppliedRoute path="/index.html" exact component={Home}/>
			<AppliedRoute path="/home" exact component={Home}/>

			{/* Finally, catch all unmatched routes */}
			<Route component={NotFound} />
		</Switch>
);
